import { apiRequest } from "@/lib/auth-api";

export interface OpenAICompatibleConfig {
    configured: boolean;
    agent_name: string | null;
    base_url: string | null;
    model_id: string | null;
    api_key_configured: boolean;
    api_key_masked: string | null;
    storage: "DATABASE_ENCRYPTED";
    updated_at: string | null;
    updated_by: string | null;
}

export interface OpenAICompatibleTestResult {
    status: "SUCCESS" | "FAILED";
    model_id: string;
    tested_at: string;
    message: string;
}

export function loadOpenAICompatibleConfig(): Promise<OpenAICompatibleConfig> {
    return apiRequest<OpenAICompatibleConfig>("/integrations/openai-compatible", { method: "GET" });
}

export function saveOpenAICompatibleConfig(
    csrfToken: string,
    input: { agent_name: string; base_url: string; model_id: string; api_key?: string },
): Promise<OpenAICompatibleConfig> {
    return apiRequest<OpenAICompatibleConfig>("/integrations/openai-compatible/save", {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken },
        body: JSON.stringify(input),
    });
}

export function testOpenAICompatibleConfig(csrfToken: string): Promise<OpenAICompatibleTestResult> {
    return apiRequest<OpenAICompatibleTestResult>("/integrations/openai-compatible/test", {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken },
    });
}
